import { Link } from 'react-router-dom';
import { siteConfig, footerNavColumns, socialLinks } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 rounded-2xl mx-4 md:mx-6 mb-4 md:mb-6 overflow-hidden">
      <div className="px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6 cursor-pointer whitespace-nowrap">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg md:text-xl"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">
                {siteConfig.name}
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6">
              {siteConfig.tagline}
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerNavColumns.map((column) => (
            <div key={column.title}>
              <h4 className="text-background-50 font-semibold text-sm mb-5">
                {column.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-foreground-400 hover:text-background-50 text-sm transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-5">
              订阅推送
            </h4>
            <p className="text-foreground-400 text-sm mb-4">
              第一时间获取最新吃瓜爆料，不错过任何精彩内容。
            </p>
            <div className="flex gap-0">
              <input
                type="email"
                placeholder="输入邮箱地址"
                className="flex-1 px-4 py-2.5 text-sm bg-foreground-800 text-background-50 placeholder-foreground-500 rounded-l-lg border border-foreground-700 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <button
                type="button"
                className="w-11 h-11 flex items-center justify-center bg-primary-500 text-background-50 rounded-r-lg hover:bg-primary-600 transition-colors cursor-pointer"
                aria-label="订阅"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="relative px-6 md:px-10 pb-10 md:pb-14">
        <div className="relative z-10 flex flex-col sm:flex-row items-center justify-between gap-3 pt-6 border-t border-foreground-800">
          <p className="text-foreground-500 text-xs">
            &copy; {siteConfig.foundedYear} - {new Date().getFullYear()} {siteConfig.name} 版权所有
          </p>
          <p className="text-foreground-500 text-xs">
            本站内容仅供娱乐参考，不构成任何投资或法律建议
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 flex items-end justify-center pointer-events-none select-none">
          <span className="font-heading font-black text-[6rem] md:text-[8rem] text-foreground-800/30 leading-none tracking-tighter whitespace-nowrap">
            {siteConfig.name}
          </span>
        </div>
      </div>
    </footer>
  );
}